/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction } from '@reduxjs/toolkit';

export const addError = createAction<any>('ADD_ERROR');
export const removeErrors = createAction('REMOVE_ERRORS');
